import type {
  GetAllQuoteEntity,
  InventoryContract,
  InventoryContractResponse,
  Quote,
  QuoteContent,
  WebreportApiResponse,
} from '@/features/Quotes/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class QuotesHttpService extends HttpService {
  loadQuoteById(id: string): HttpClientResponse<Quote> {
    return this.httpClient.get(`angebot/${id}`);
  }

  loadWebreportById(id: string): HttpClientResponse<WebreportApiResponse> {
    return this.httpClient.get(`angebot/${id}/webreport/frontend`);
  }

  updateQuote(
    id: string,
    title: string,
    content: QuoteContent,
  ): HttpClientResponse<Quote> {
    return this.httpClient.put(`angebot/${id}`, {
      data: {
        titel: title,
        content,
      },
    });
  }

  saveQuote(
    clientId: number,
    title: string,
    content: QuoteContent,
  ): HttpClientResponse<Quote> {
    return this.httpClient.post('angebot', {
      data: {
        clientId,
        titel: title,
        content,
      },
    });
  }

  generateInventoryContract(
    data: InventoryContract,
    calculationId: string,
    contractId: number | null,
  ): HttpClientResponse<InventoryContractResponse> {
    return this.httpClient.post('angebot/bestandsvertrag', {
      data,
      params: {
        berechnungsId: calculationId,
        contractId,
      },
    });
  }

  getAll(): HttpClientResponse<GetAllQuoteEntity[]> {
    return this.httpClient.get('angebot/getAll');
  }
}
